Vue.config.devtools = true

Vue.component('product-carousel', {
  template: "#product-carousel-template",
  props: {
    images: {
      type: Array,
      required: true
    },
    isModal: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      currentThumbnail: null,
      innerWidth: window.innerWidth,
      slideWidth: null,
      slideHeight: null,
      thumbnailContainer: null,
      thumbBackActive: false,
      thumbForwardActive: false,
      carouselId: Math.floor(Math.random() * 100)
    }
  },
  methods: {
    goToSlide(slideElement, thumbnailElement) {
      let isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent)
      let el = document.querySelector(slideElement)

      this.setActiveThumbnail(thumbnailElement)
      if(!isSafari) {
        el.scrollIntoView({
          block: 'nearest',
          behavior: 'smooth'
        })
      }

      if(isSafari) {
        let scrollContainer = document.querySelector(`.slides-${this.carouselId}`)
        let left = el.offsetLeft - scrollContainer.offsetLeft
        scrollContainer.scrollTo({
          behavior: 'smooth',
          left: left
        })
      }
    },
    setActiveThumbnail(thumbnailElement) {
      if (this.currentThumbnail !== null) {
        this.currentThumbnail.classList.toggle('active')
      }

      this.currentThumbnail = document.querySelector(thumbnailElement)
      this.currentThumbnail.classList.toggle('active')
    },
    onResize() {
      if(this.isModal) {
        let modalWidth = document.querySelector('.upsell-modal').offsetWidth
        this.innerWidth = modalWidth
      } else {
        this.innerWidth = window.innerWidth
      }
    },
    onThumbnailScroll() {
      let thumbContainer = this.thumbnailContainer
      if(thumbContainer.scrollTop === 0 || thumbContainer.scrollLeft === 0) {
        this.thumbForwardActive = true
        this.thumbBackActive = false
      }
      // if((thumbContainer.scrollTop > 0 || thumbContainer.scrollLeft > 0) && (thumbContainer.scrollHeight - thumbContainer.scrollTop < thumbContainer.clientHeight || thumbContainer.scrollWidth - thumbContainer.scrollLeft < thumbContainer.clientWidth)) {
      //   this.thumbForwardActive = true
      //   this.thumbBackActive = true
      // }
      //
    },
    onThumbnailResize() {
      let thumbContainer = this.thumbnailContainer
      if(thumbContainer.scrollHeight > thumbContainer.clientHeight || thumbContainer.scrollWidth > thumbContainer.clientWidth) {
        this.thumbForwardActive = true
      } else {
        this.thumbForwardActive = false
        this.thumbBackActive = false
      }
    },
    setSlideSize() {
      let newWidth = this.innerWidth
      if(newWidth < 768) {
        this.slideWidth = newWidth
        this.slideHeight = newWidth
      }
      if(newWidth >= 768 && newWidth < 1200) {
        this.slideWidth = newWidth * 0.5
        this.slideHeight = newWidth * 0.5
      }
      if(newWidth >= 1200) {
        this.slideWidth = 685
        this.slideHeight = 685
      }
    },
    scrollForwards() {
      console.log(this.innerWidth)
      if(this.innerWidth < 1200) {
        this.thumbnailContainer.scrollBy({
          top: 150,
          behavior: "smooth"
        })
      } else {
        this.thumbnailContainer.scrollBy({
          left: 150,
          behavior: "smooth"
        })
      }
    },
    scrollBackwards() {
      if(this.slideWidth > 1200) {
        this.thumbnailContainer.scrollBy({
          top: -150,
          behavior: "smooth"
        })
      } else {
        this.thumbnailContainer.scrollBy({
          left: -150,
          behavior: "smooth"
        })
      }
    },
    handleize(string) {
      return string.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '')
    }
  },
  watch: {
    innerWidth() {
      this.setSlideSize()
    }
  },
  mounted() {
    this.setSlideSize()
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize)
      this.thumbnailContainer = document.querySelector(`.thumb-container-${this.carouselId}`)
      this.thumbnailContainer.addEventListener('scroll', this.onThumbnailScroll)
      window.addEventListener('resize', this.onThumbnailResize)
      this.onThumbnailResize()
      if(this.isModal) {
        let modalWidth = document.querySelector('.upsell-modal').offsetWidth
        this.innerWidth = modalWidth
      }
    })
    bus.$on('swatch-clicked', colorVariants => {
      let unfilteredThumbnails = Array.from(document.querySelectorAll(`.thumb-${this.carouselId}`))
      let thumbnails = unfilteredThumbnails.filter(thumb => thumb.dataset.thumbId !== null)
      let matchingElement = thumbnails.filter(thumb => {
        let id = Number(thumb.dataset.thumbId)
        return colorVariants.some(variant => {
          return variant.id === id
        })
      })
      if (matchingElement[0]) {
        this.goToSlide(`#slide-${this.carouselId}-${matchingElement[0].id.split("-").pop()}`, `#thumb-${this.carouselId}-${matchingElement[0].id.split("-").pop()}`)
      }
    })
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize)
  }
})

Vue.component('product-upsell', {
  template: "#product-upsell",
  props: {
    upsellSettings: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      currentlyActiveModal: null
    }
  },
  watch: {
    currentlyActiveModal() {
      if(this.currentlyActiveModal !== null) {
        document.body.style.width = "100%"
        document.body.style.position = 'fixed';
        document.body.style.top = `-${window.scrollY}px`;
      } else {
        const scrollY = document.body.style.top;
        document.body.style.position = '';
        document.body.style.top = '';
        window.scrollTo(0, parseInt(scrollY || '0') * -1);
      }
    }
  },
  methods: {
    priceToMoney(price) {
      let priceMath = price / 100
      return numeral(priceMath).format('$0,0')
    },
    truncateMobile(string, characters) {
      return `${string.substring(0, characters)}...`
    },
    setActiveModal(index) {
      this.currentlyActiveModal = index
    },
    closeModal() {
      this.currentlyActiveModal = null
    }
  }
})

Vue.component('product-buy-box', {
  template: "#product-buy-box",
  props: {
    product: {
      type: Object,
      required: true
    },
    options: {
      type: Array,
      required: true
    },
    upsellSettings: {
      type: Object
    },
    showUpsell: {
      type: Boolean,
      default: false
    },
    isModal: {
      type: Boolean,
      default: false
    }
  },
  data() {
    
    return {
      currentColorName: "",
      currentColorVariants: null,
      currentSizeName: "",
      currentSizeVariants: null,
      selectedVariant: null,
      currentQuantity: 1,
      on_sale: false
    }
  },
  mounted(){
    var url = location.href;
    var url_pieces = url.split("/");
    if(url_pieces.pop() == this.product.handle){ 
      var on_sale = true;
      var price_check = this.product.variants[0].price;
      var compare_check = this.product.variants[0].compare_at_price;
      $.each(this.product.variants,function(){
        if(this.price != price_check || this.compare_at_price != compare_check){
          on_sale = false; 
        }
      });

      if(price_check >= compare_check){
        on_sale = false; 
      }
      
     	this.on_sale = on_sale;

      if(on_sale){
        $('.buy-box__prices-price-compare').show();
      }
    }
  },
  computed: {
    productPrice() {
      let highest_price = 0;
      $.each(this.product.variants,function(){
        if(this.price > highest_price){
          highest_price = this.price;
        }
      });
      //let price = this.product.price / 100
      let price = highest_price / 100
      return numeral(price).format('$0,0')
    },
    CompareproductPrice() {
       
       let price = this.product.price / 100
        
      let compare_price = this.product.compare_at_price / 100
      if(compare_price > price){
        return numeral(compare_price).format('$0,0')
      }
      },
    ProductHandlevalue(){
   	 let product_handle = this.product.handle
     return product_handle
    },
    containsColors() {
      return this.options.some(option => option.name === "color" || option.name === "Color")
    },
    colorOptions() {
      if(this.containsColors) {
        return this.options.filter(option => option.name === "color" || option.name === "Color")[0]
      }
      return null
    },
    containsSizes() {
      return this.options.some(option => option.name === "size" || option.name === "Size")
    },
    sizeOptions() {
      if(this.containsColors) {
        return this.options.filter(option => option.name === "size" || option.name === "Size")[0]
      }
      return null
    }
  },
  methods: {
    addToCart() {
      if(this.isModal) {
        this.$emit('close-modal')
      }
      let url = '/cart/add.js'
      let data = {
        id: this.selectedVariant.id,
        quantity: this.currentQuantity
      }
      axios.post(url, data).then((response) => {
        $('body').trigger('added.ajaxProduct')
      }).catch((error) => {
        console.error(error)
      })
    },
    setColor(color) {
      this.setCurrentColorName(color)
      this.setCurrentColorVariants(color)
      this.setSelectedVariant()
      this.emitColorSelection(color)
    },
    setSize(size) {
      this.setCurrentSizeName(size)
      this.setCurrentSizeVariants(size)
      this.setSelectedVariant()
    },
    setCurrentColorName(color) {
      this.currentColorName = color
      this.currentSizeName = this.currentSizeName;
      this.selectedVariant = null
    },
    setCurrentColorVariants(color) {
      let colorVariants = this.product.variants.filter(variant => {
        return variant.options.some(option => option === color)
      })
      this.currentColorVariants = colorVariants
    },
    setCurrentSizeName(size) {
      this.currentSizeName = size
    },
    setCurrentSizeVariants(size) {
      let sizeVariants = this.product.variants.filter(variant => {
        return variant.options.some(option => option === size)
      })
      this.currentSizeVariants = sizeVariants
    },
    setSelectedVariant() {
      if(
        this.currentColorName !== "" &&
        this.currentSizeName !== "" &&
        this.currentColorVariants !== null &&
        this.setCurrentSizeVariants !== null) {
      
        this.selectedVariant = this.currentColorVariants.filter(variant => variant.options.some(option => option === this.currentSizeName))[0];
        var pro_name = this.selectedVariant.name;
        var final_pro_name = pro_name.split('-')[0];
        
        var price = this.selectedVariant.price; 
        let priceMath = price / 100;
        
        if($('.buy-box__prices').hasClass(this.product.handle)){    
      	   $('.buy-box__prices.'+this.product.handle).find('.buy-box__prices-price').html(numeral(priceMath).format('$0,0'));
        }else{
        	$('.product-upsell__modal.active').find('.buy-box__prices-price').html(numeral(priceMath).format('$0,0'));
       }
        /* compare at price */
        
        if(this.selectedVariant.compare_at_price > this.selectedVariant.price){
         var price_compare = this.selectedVariant.compare_at_price; 
          let priceMath_compare = price_compare / 100;
          
           if($('.buy-box__prices').hasClass(this.product.handle)){    
           	$('.buy-box__prices.'+this.product.handle).find('.buy-box__prices-price-compare').html(numeral(priceMath_compare).format('$0,0')).show();
           }else{
           	$('.product-upsell__modal.active').find('.buy-box__prices-price-compare').html(numeral(priceMath_compare).format('$0,0')).show();
           }
           
        }else{
  
          	$('.buy-box__prices-price-compare').hide();
   
          
        }
      
      }
      
    
    },
    
    setCurrentQuantity(event) {
      this.currentQuantity = parseInt(event.target.value)
    },
    itemOutOfStock(option) {
      let optionVariants = this.product.variants.filter(variant => variant.options.includes(option))
      return optionVariants.every(variant => variant.available === false)
    },
    itemOnSale(option){
      var on_sale = false;
      $.each(this.product.variants,function(){
        if(this.option2 == option && this.price < this.compare_at_price){
          on_sale = true;
        }
      });
      
      return this.on_sale ? false : on_sale;
    },
    sizeOutOfStock(option) {
      if (this.currentColorVariants !== null) {
        let sizesOutOfStock = this.currentColorVariants.filter(variant => variant.available === false)
        return sizesOutOfStock.some(size => size.options.includes(option))
      }
    },
    handleize(string) {
      return string.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '')
    },
    emitColorSelection(color) {
      let colorVariants = this.product.variants.filter(variant => variant.options.includes(color))
      bus.$emit('swatch-clicked', colorVariants)
    },
    openSizeChart() {
      document.querySelector('.size-guide-modal').style.display = "flex"
      document.querySelector('body').style.overflow = "hidden"
    }
  }
})

const bus = new Vue()

const productApp = new Vue({
  el: "#productApp"
});
